import {combineReducers} from 'redux';

import {account} from 'src/shared/account/reducers';
import {auth} from 'src/shared/auth/reducers';
import {config} from 'src/shared/config/reducers';
import {currentView} from 'src/shared/currentView/reducers';
import {datacast} from 'src/shared/datacast/reducers';
import {extendedProfile} from 'src/shared/extendedProfile/reducers';
import {hic} from 'src/shared/hic/reducers';
import {outages} from 'src/shared/outages/reducers';
import {params} from 'src/shared/params/reducers';
import {redirectUrl} from 'src/shared/redirect/reducers';
import {reportIssueEligibility} from 'src/shared/reportIssue/reducers';
import {resourceStatus} from 'src/shared/resourceStatus/reducers';
import {smsEnrollment} from 'src/shared/smsEnrollment/reducers';
import {smsNumber} from 'src/pages/reportIssue/store/reducers/smsNumber';
import {user} from 'src/shared/user/reducers';
import {watchtower} from 'src/shared/watchtower/reducers';

export const reducers = combineReducers({
  account,
  auth,
  config,
  currentView,
  datacast,
  extendedProfile,
  hic,
  outages,
  params,
  redirectUrl,
  reportIssueEligibility,
  resourceStatus,
  smsEnrollment,
  smsNumber,
  user,
  watchtower,
});
